import { useContext, useEffect, useState } from "react";
import { DrawerContext } from "@CONTEXTS";
import DocumentDetail from "./detail";

const useTabs = () => {
  const { data } = useContext(DrawerContext);
  const [state, setState] = useState([]);

  useEffect(() => {
    const tabs = [
      {
        title: "Belge Detayı",
        component: <DocumentDetail />,
      },
    ];

    setState(tabs);
  }, [data]);

  return state;
};

export default useTabs;
